// extracted by mini-css-extract-plugin
export default {"tabs":"HwfW210T0LBiOTcvVQZM"};